import React, { memo } from "react";
import Footer from "./Footer";

const FooterContainer = () => {
  return <Footer />;
};

export default memo(FooterContainer);
